export const DEFAULT_ROOFING_MATERIAL_THICKNESS = 1 / 2;
export const DEFAULT_ROOFING_MATERIAL_EXTENSION = 3 / 4;
export const VALLEY_RAIL_TOLERANCE = 0.1;
export const RIDGE_RAIL_TOLERANCE = 0.5;
export const EAVE_RETURN_RAIL_EPSILON = 1e-2;
